<template>
  <div>
    <v-table class="result_table" density="compact" style="border-radius: 5px">
      <thead class="bg-secondary">
        <tr>
          <th>Détails</th>

          <th>Nom - Prénom</th>
          <th>Nb boucles</th>
          <th>Doss.</th>

          <th>Temps cumulé</th>
          <th>Club</th>
        </tr>
      </thead>
      <tbody v-if="filteredRunners.length > 0">
        <tr v-for="(runner, id_runner) in filteredRunners" :key="id_runner">
          <td>
            <v-btn density="compact" class="gradient text-white" variant="text" @click="display_dialog(runner)">+ détails</v-btn>
          </td>

          <td>
            <b>{{ runner.nom }} {{ runner.prenom }}</b>
          </td>
          <td>
            <b>{{ runner.loop_results.length }}</b>
          </td>
          <td>{{ runner.dossard }}</td>

          <td>
            <b class="text-accent" style="font-size: 1.1rem">{{ get_temps_cumul(runner) }}</b>
          </td>
          <td>{{ runner.club }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7" v-if="filters.challenge != 'Tous' || filters.sexe != 'Tous' || filters.search != ''" class="text-center">Aucun participant ne correspond à votre recherche</td>
          <td colspan="7" v-else class="text-center">En attente des résultats</td>
        </tr>
      </tbody>
    </v-table>
    <v-dialog v-model="show_dialog" width="500">
      <v-card>
        <v-card-text>
          <ResultatsCoureur :runner="selected_runner"></ResultatsCoureur>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" block @click="show_dialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ResultatsCoureur from "@/components/Classements/ResultatsCoureur.vue";
export default {
  components: {
    ResultatsCoureur,
  },
  props: ["challenge", "filters"],
  data() {
    return {
      selected_runner: null,
      show_dialog: false,
    };
  },
  methods: {
    get_temps_cumul(runner) {
      let duration = moment.duration(runner.temps_cumul);
      let res_duration = "";
      if (duration.days() === 0) {
        res_duration = moment.utc(runner.temps_cumul).format("HH:mm:ss");
      } else {
        res_duration = `${duration.days()}j ${moment.utc(runner.temps_cumul).format("HH:mm:ss")}`;
      }
      return res_duration;
    },
    display_dialog(runner) {
      this.selected_runner = runner;
      this.show_dialog = true;
    },
  },
  computed: {
    filteredRunners() {
      if (!this.challenge || !this.challenge.runner_results) return [];
      let runners = this.challenge.runner_results;
      if (this.filters.challenge != "Tous") {
        runners = runners.filter((runner) => {
          return runner.challenge === this.filters.challenge;
        });
      }
      if (this.filters.sexe != "Tous") {
        runners = runners.filter((runner) => {
          return runner.sexe === this.filters.sexe;
        });
      }
      if (this.filters.search != "") {
        runners = runners.filter((runner) => {
          return runner.nom.toLowerCase().includes(this.filters.search.toLowerCase()) || runner.prenom.toLowerCase().includes(this.filters.search.toLowerCase());
        });
      }

      return runners;
      /* return this.$store.state.runners.filter((runner) => {
                return runner.challenge === this.selected_challenge && runner.sexe === this.selected_sexe;
            }); */
    },
  },
};
</script>

<style lang="scss" >
.result_table * {
  text-wrap: nowrap !important;
}
.table_classement_challenge thead {
  background-color: #41678e !important;
  color: white !important;
}
.table_classement_challenge th {
}
</style>